export default __webpack_public_path__ + "static/media/frg--castle-hill.d0ae4888.png";